export default "__VITE_ASSET__bpAvLKDR__"